import {useProductQuestionStatisticsFragment} from "./useProductQuestionStatisticsFragment";
import {useProductQuestionConnectionFragment} from "./useProductQuestionConnectionFragment";
import * as React from "react";
import {questionConnectionPageSize} from "../utils/constants";

export const useShowMoreQuestions = () => {
    const {
        loading: statisticsLoading,
        model: {
            count
        }
    } = useProductQuestionStatisticsFragment();
    const {
        loading: connectionLoading,
        model: {
            questionEdgeCount,
            pageInfo: {
                hasNextPage
            }
        }
    } = useProductQuestionConnectionFragment();

    const number = Math.min(questionConnectionPageSize, count - questionEdgeCount);

    return {
        loading: statisticsLoading || connectionLoading,
        hasNextPage,
        headingTitle: (
            <>
                Showing{' '}
                <strong>
                    {questionEdgeCount > 0 ? 1 : 0} - {questionEdgeCount}{' '}
                </strong>
                of{' '}
                <strong>
                    {count}{' '}
                </strong>
            </>
        ),
        buttonTitle: `Show ${number} more question${number === 1 ? '' : 's'}`
    };
}